export default "/_next/static/images/gold-ebf66eb7a06cd27a8c9bcf15e07e8b20.png";